import { useEffect, useRef, useState } from "react";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PropTypes from "prop-types";

const truncateAgentId = (agentId, visibleLength = 7) => {
  if (!agentId || agentId.length <= visibleLength) {
    return agentId || "-";
  }

  return `${agentId.slice(0, visibleLength)}…`;
};

export const AgentIdCell = ({ agentId }) => {
  const [copied, setCopied] = useState(false);
  const resetTimerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (resetTimerRef.current) {
        clearTimeout(resetTimerRef.current);
      }
    };
  }, []);

  const handleCopy = async (event) => {
    event.stopPropagation();

    if (!agentId) {
      return;
    }

    try {
      await navigator.clipboard.writeText(agentId);
      setCopied(true);

      if (resetTimerRef.current) {
        clearTimeout(resetTimerRef.current);
      }

      resetTimerRef.current = setTimeout(() => {
        setCopied(false);
      }, 1500);
    } catch (error) {
      console.error("No fue posible copiar el ID del agente:", error);
    }
  };

  const displayValue = truncateAgentId(agentId);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0 }}>
      <Tooltip title={copied ? "Copiado" : "Copiar ID"} arrow>
        <span>
          <IconButton
            size="small"
            onClick={handleCopy}
            aria-label={copied ? "ID copiado" : "copiar ID del agente"}
            disabled={!agentId}
            sx={{ padding: "2px", width: 20, height: 20 }}
          >
            <ContentCopyIcon sx={{ fontSize: 14 }} />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={agentId || "-"} arrow placement="top-start">
        <Typography
          variant="body2"
          component="span"
          noWrap
          sx={{
            maxWidth: 150,
            fontFamily: "monospace",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {displayValue}
        </Typography>
      </Tooltip>

    </Box>
  );
};

AgentIdCell.propTypes = {
  agentId: PropTypes.string,
};